(function () {
  "use strict";

  function formatMoney(cents, format) {
    if (typeof cents === "string") {
      cents = cents.replace(".", "");
    }

    let value = "";
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || (window.theme && window.theme.moneyFormat) || "${{amount}}";

    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return "0";
      }

      number = (number / 100.0).toFixed(precision);

      const parts = number.split(".");
      const whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const fraction = parts[1] ? decimal + parts[1] : "";

      return whole + fraction;
    }

    switch ((formatString.match(placeholderRegex) || [null, "amount"])[1]) {
      case "amount":
        value = formatWithDelimiters(cents, 2);
        break;
      case "amount_no_decimals":
        value = formatWithDelimiters(cents, 0);
        break;
      case "amount_with_comma_separator":
        value = formatWithDelimiters(cents, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        value = formatWithDelimiters(cents, 0, ".", ",");
        break;
      default:
        value = formatWithDelimiters(cents, 2);
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  function getSteps(bar) {
    return Array.from(bar.querySelectorAll("[data-vdp-step]"));
  }

  function getActiveStep(bar) {
    return (
      bar.querySelector("[data-vdp-step].is-active") ||
      bar.querySelector(
        `[data-vdp-step][data-variant-id="${bar.dataset.currentVariantId}"]`
      )
    );
  }

  function getOptionButtons(optionBlock) {
    const swatchInner = optionBlock.querySelector(".product__color-swatches--inner");
    const chipWrap = optionBlock.querySelector(".product__color-chips");

    let buttons = [];
    if (swatchInner) {
      buttons = Array.from(
        swatchInner.querySelectorAll('button[data-button][data-option-value]')
      );
    } else if (chipWrap) {
      buttons = Array.from(
        chipWrap.querySelectorAll('button[data-button][data-option-value]')
      );
    }

    return buttons.filter((b) => b && b.offsetParent !== null);
  }

  function computeRowMetrics(optionBlock) {
    const buttons = getOptionButtons(optionBlock);
    if (!buttons.length) return null;

    const firstRect = buttons[0].getBoundingClientRect();
    const lastRect = buttons[buttons.length - 1].getBoundingClientRect();

    const optionRect = optionBlock.getBoundingClientRect();
    const cs = window.getComputedStyle(optionBlock);
    const padLeft = parseFloat(cs.paddingLeft) || 0;
    const contentLeft = optionRect.left + padLeft;

    const rowWidth = Math.max(0, lastRect.right - firstRect.left);
    const rowLeft = Math.max(0, firstRect.left - contentLeft);

    const centers = new Map();
    buttons.forEach((btn) => {
      const rect = btn.getBoundingClientRect();
      const val = String(btn.dataset.optionValue || "");
      const centerPx = rect.left + rect.width / 2 - firstRect.left;
      centers.set(val, centerPx);
    });

    return { rowWidth, rowLeft, centers };
  }

  function getProductScope(node) {
    return node.closest(".product__meta") || node.closest(".shopify-section") || document;
  }

  function getQuantityInput(bar) {
    const scope = getProductScope(bar);
    return (
      scope.querySelector('[data-product-form] [data-quantity-input]') ||
      scope.querySelector("[data-quantity-input]")
    );
  }

  function getCurrentQuantity(bar) {
    const input = getQuantityInput(bar);
    if (!input) return 1;

    const qty = parseInt(input.value, 10);
    if (!Number.isFinite(qty) || qty < 1) return 1;

    return qty;
  }

  function updateCurrentSavings(bar) {
    const current = bar.querySelector("[data-vdp-current]");
    const activeStep = getActiveStep(bar);

    if (!current || !activeStep) return;

    const baseAmount = parseInt(activeStep.dataset.saveAmount || "0", 10);
    const percent = parseInt(activeStep.dataset.savePercent || "0", 10);
    const qty = getCurrentQuantity(bar);

    if (baseAmount > 0) {
      const totalAmount = baseAmount * qty;
      current.innerHTML = `Du sparst <span class="vdp__em">${formatMoney(totalAmount)}</span>`;
    } else if (percent > 0) {
      current.innerHTML = `Du sparst <span class="vdp__em">${percent}%</span>`;
    } else {
      current.textContent = "Spare mit Mehrfachpacks";
    }
  }

  function setActiveStep(bar, variantId) {
    const steps = getSteps(bar);
    if (!steps.length) return;

    let activeIndex = 0;
    steps.forEach((step, idx) => {
      const isActive = String(step.dataset.variantId) === String(variantId);
      step.classList.toggle("is-active", isActive);
      if (isActive) activeIndex = idx;
    });

    const fill = bar.querySelector("[data-vdp-fill]");

    const denom = steps.length * 2;
    const numer = activeIndex * 2 + 1;
    let pct = denom ? (numer / denom) * 100 : 0;

    if (activeIndex >= steps.length - 1) pct = 100;

    if (fill) fill.style.width = `${pct}%`;

    bar.dataset.currentVariantId = String(variantId);

    updateCurrentSavings(bar);
  }

  function scheduleSync(bar) {
    if (!bar) return;
    if (bar.__vdpSyncRaf) cancelAnimationFrame(bar.__vdpSyncRaf);

    bar.__vdpSyncRaf = requestAnimationFrame(() => {
      const optionBlock = bar.closest(".product__option");
      if (!optionBlock) return;

      const metrics = computeRowMetrics(optionBlock);
      if (!metrics || metrics.rowWidth <= 0) return;

      bar.style.setProperty("--vdp-width", `${Math.round(metrics.rowWidth)}px`);
      bar.style.setProperty("--vdp-left", `${Math.round(metrics.rowLeft)}px`);

      const activeStep = getActiveStep(bar);
      const activeValue = activeStep ? String(activeStep.dataset.optionValue || "") : "";
      const centerPx = metrics.centers.get(activeValue);

      if (typeof centerPx === "number") {
        bar.style.setProperty("--vdp-pointer-left", `${Math.round(centerPx)}px`);

        const fill = bar.querySelector("[data-vdp-fill]");
        if (fill) {
          const steps = getSteps(bar);
          const activeIndex = activeStep
            ? parseInt(activeStep.dataset.stepIndex || "0", 10)
            : 0;
          const lastIndex = Math.max(steps.length - 1, 0);

          let pct;
          if (activeIndex >= lastIndex) {
            pct = 100;
          } else {
            pct = (centerPx / metrics.rowWidth) * 100;
          }

          pct = Math.max(0, Math.min(100, pct));
          fill.style.width = `${pct}%`;
        }

        bar.dataset.vdpReady = "true";
      }
    });
  }

  function updateBarsInScope(node) {
    const scope = getProductScope(node);
    scope.querySelectorAll("[data-vdp]").forEach((bar) => {
      updateCurrentSavings(bar);
      scheduleSync(bar);
    });
  }

  function initBar(bar) {
    if (!bar || bar.dataset.vdpInitialized === "true") return;
    bar.dataset.vdpInitialized = "true";
    bar.dataset.vdpReady = "false";

    bar.addEventListener("click", (evt) => {
      const stepBtn = evt.target.closest("[data-vdp-step]");
      if (!stepBtn || stepBtn.disabled) return;

      const optionValue = stepBtn.dataset.optionValue;
      const optionBlock = bar.closest(".product__option");
      if (!optionBlock || !optionValue) return;

      const optionButtons = optionBlock.querySelectorAll(
        "[data-button][data-option-value]"
      );

      for (const btn of optionButtons) {
        if (btn.dataset.optionValue === optionValue) {
          btn.click();
          return;
        }
      }

      const select = optionBlock.querySelector('select[name^="options["]');
      if (select) {
        select.value = optionValue;
        select.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });

    const initialVariantId = bar.dataset.currentVariantId;
    if (initialVariantId) setActiveStep(bar, initialVariantId);

    bar.__vdpSetActive = (id) => {
      setActiveStep(bar, id);
      scheduleSync(bar);
    };

    scheduleSync(bar);
    updateCurrentSavings(bar);
  }

  function initAll(root) {
    const scope = root || document;
    scope.querySelectorAll("[data-vdp]").forEach(initBar);
  }

  document.addEventListener("DOMContentLoaded", () => initAll(document));

  document.addEventListener("product:variant-change", (evt) => {
    const variant = evt.detail && evt.detail.variant;
    if (!variant || !variant.id) return;

    document.querySelectorAll("[data-vdp]").forEach((bar) => {
      const hasVariant = bar.querySelector(
        `[data-vdp-step][data-variant-id="${variant.id}"]`
      );

      if (hasVariant && bar.__vdpSetActive) {
        bar.__vdpSetActive(variant.id);
      } else {
        scheduleSync(bar);
      }
    });
  });

  document.addEventListener("change", (evt) => {
    if (evt.target && evt.target.matches("[data-quantity-input]")) {
      updateBarsInScope(evt.target);
    }
  });

  document.addEventListener("input", (evt) => {
    if (evt.target && evt.target.matches("[data-quantity-input]")) {
      updateBarsInScope(evt.target);
    }
  });

  document.addEventListener("click", (evt) => {
    const trigger = evt.target && evt.target.closest("[data-add-quantity], [data-subtract-quantity]");
    if (!trigger) return;

    requestAnimationFrame(() => {
      updateBarsInScope(trigger);
    });
  });

  window.addEventListener("resize", () => {
    document.querySelectorAll("[data-vdp]").forEach((bar) => scheduleSync(bar));
  });

  document.addEventListener("quickview:loaded", () => initAll(document));

  document.addEventListener("shopify:section:load", (evt) => {
    if (evt.target) initAll(evt.target);
  });
})();